import { toDate } from "./format";

// Código corto para mostrar y mencionar una orden, por ejemplo "#A7K2QX".
export function shortCode(orderId = "") {
  return `#${orderId.slice(0, 6).toUpperCase()}`;
}

export function otherParticipant(order, uid) {
  return (order.participantes || []).find((p) => p !== uid) || null;
}

export function unreadCount(order, uid) {
  const value = order.noLeidos?.[uid];
  return Number.isInteger(value) && value > 0 ? value : 0;
}

export function totalUnread(orders, uid) {
  return orders.reduce((sum, order) => sum + unreadCount(order, uid), 0);
}

function lastActivity(order) {
  return (toDate(order.ultimoMensajeEn) || toDate(order.creadoEn))?.getTime() || 0;
}

// Primero las órdenes con mensajes sin leer (el mensaje más reciente arriba); el resto mantiene su orden.
export function sortByUnread(orders, uid) {
  const withUnread = orders.filter((o) => unreadCount(o, uid) > 0).sort((a, b) => lastActivity(b) - lastActivity(a));
  return [...withUnread, ...orders.filter((o) => unreadCount(o, uid) === 0)];
}

// Índice del primer mensaje no leído: el N-ésimo mensaje del otro contando desde el final.
// Devuelve -1 si no hay no leídos.
export function firstUnreadIndex(comments, uid, unread) {
  if (!unread) return -1;
  let seen = 0;
  for (let i = comments.length - 1; i >= 0; i--) {
    if (comments[i].autorUid === uid) continue;
    seen++;
    if (seen === unread) return i;
  }
  // Hay más no leídos que mensajes cargados: todos los del otro son nuevos.
  return comments.findIndex((c) => c.autorUid !== uid);
}
